const phrases = `Por favor, investigue esto y arréglelo para que no vuelva a suceder.
Agradezco su pronta atención a este asunto.
Es importante repararlo lo antes posible para evitar más problemas.
Gracias por su pronta atención a este problema.
También estoy pensando en hacer una denuncia oficial sobre esto.
Por favor tome las medidas necesarias para que esto no vuelva a suceder.
Es importante asegurarse de que esto no le pase a nadie más.
Ambas opciones tienen cosas buenas y no tan buenas.
Cada opción tiene sus propias ventajas y desventajas.
Es importante pensar en lo que funciona mejor para usted y sus objetivos.
Fue un momento especial que siempre apreciaré.
¡Os mantendré informados sobre cómo van las cosas!
Me sorprendió completamente, para ser honesto.
Es importante pensar en ello.
Creo que podemos encontrar un equilibrio
Algunas personas piensan que esto es una buena idea y otras no.
Es importante hablar de ello.
Te haré saber cómo va
¡Gracias por su atención!
Atentamente
espero que estés bien
Gracias por escuchar
Ante esta situación
Cuídate`;
export default phrases;